import { useState } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

const useAnalyzeCV = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);

    const getAnalyzeCV = async (file) => {
        setLoading(true);
        setError(null);
        try {
            const formData = new FormData();
            formData.append("resume", file, file.name);

            const response = await authenticatedFetch(
                `${window.ENV.BACKEND_URL}/api/secured/admin/prospect/analyzeCV`,
                {
                    method: 'POST',
                    body: formData,
                }
            );

            if (!response.ok) {
                const errorJson = await response.json();
                console.error("Error response received:", errorJson);
                throw new Error(errorJson?.detail || errorJson?.title || response.statusText || String(response.status));
            }

            const data = await response.json();
            setResponse(data);
            return { data, error: null };
        } catch (err) {
            console.error("getAnalyzeCV error:", err, err.detail);
            setError(err.message || err.detail);
            return { data: null, error: err };
        } finally {
            setLoading(false);
        }
    };

    const resetError = () => setError(null);

    return { getAnalyzeCV, loading, error, response, resetError };
};

export default useAnalyzeCV;
